import { render } from "./KpiCard.vue?vue&type=template&id=97e987a8&scoped=true"
import script from "./KpiCard.vue?vue&type=script&lang=js"
export * from "./KpiCard.vue?vue&type=script&lang=js"

import "./KpiCard.vue?vue&type=style&index=0&id=97e987a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e987a8"]])

export default __exports__